module.exports = __webpack_public_path__ + "img/Frente-77-02 open.abbc6b73.jpg";